import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var filledHeartIcon = /*#__PURE__*/React.createElement("svg", {
  height: "21",
  width: "24",
  viewBox: "0 0 24 21",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.79 20.467a.72.72 0 0 1-.42-.13c-.32-.21-7.79-5.266-10.24-9.753-1.46-2.678-1.79-6.455.75-8.853a6.484 6.484 0 0 1 8.82 0l1.09 1 1.08-1a6.484 6.484 0 0 1 8.82 0c2.54 2.408 2.21 6.185.75 8.863-2.45 4.487-9.9 9.543-10.22 9.753a.72.72 0 0 1-.43.12Z",
  fill: "currentColor",
  fillRule: "evenodd"
}));

export { filledHeartIcon as default };
//# sourceMappingURL=filledHeartIcon.js.map
